module.exports = __webpack_public_path__ + "static/media/switch.1474c9d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/switch.png
// module id = 1488
// module chunks = 0